// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import CourseDTO from './CourseDTO';
import DisciplineDTO from './DisciplineDTO';
import CategoryDTO from './CategoryDTO';
import YearTermDTO from './YearTermDTO';
import TermDTO from './TermDTO';
import CourseModificationChangeRequestCreditDTO from './CourseModificationChangeRequestCreditDTO';
import CourseModificationChangeRequestCourseRequisiteDTO from './CourseModificationChangeRequestCourseRequisiteDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface CourseModificationChangeRequestDTO extends EntitySelectorDTO { 
	id: string | null;
	changeRequestId: string | null;
	catalogNumber: string | null;
	courseId: string | null | null;
	course: CourseDTO | null;
	disciplineId: string | null | null;
	discipline: DisciplineDTO | null;
	title: string | null;
	description: string | null;
	objectives: string | null;
	variableHours: boolean | null | null;
	categoryId: string | null | null;
	category: CategoryDTO | null;
	install: YearTermDTO | null;
	installTermId: string | null | null;
	installYear: number | null | null;
	installTerm: TermDTO | null;
	courseModificationChangeRequestCredits: CourseModificationChangeRequestCreditDTO[] | null;
	courseModificationChangeRequestCourseRequisites: CourseModificationChangeRequestCourseRequisiteDTO[] | null;
}

const CourseModificationChangeRequestDTO = {
    className: 'CourseModificationChangeRequestDTO',
    create: (initValues?: Partial<CourseModificationChangeRequestDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: '00000000-0000-0000-0000-000000000000',
			changeRequestId: '00000000-0000-0000-0000-000000000000',
			catalogNumber: "",
			courseId: null,
			course: null,
			disciplineId: null,
			discipline: null,
			title: "",
			description: "",
			objectives: "",
			variableHours: null,
			categoryId: null,
			category: null,
			install: null,
			installTermId: null,
			installYear: null,
			installTerm: null,
			courseModificationChangeRequestCredits: [],
			courseModificationChangeRequestCourseRequisites: [],
        },
        initValues);
    },
	id: 'id',
	changeRequestId: 'changeRequestId',
	catalogNumber: 'catalogNumber',
	courseId: 'courseId',
	course: 'course',
	disciplineId: 'disciplineId',
	discipline: 'discipline',
	title: 'title',
	description: 'description',
	objectives: 'objectives',
	variableHours: 'variableHours',
	categoryId: 'categoryId',
	category: 'category',
	install: 'install',
	installTermId: 'installTermId',
	installYear: 'installYear',
	installTerm: 'installTerm',
	courseModificationChangeRequestCredits: 'courseModificationChangeRequestCredits',
	courseModificationChangeRequestCourseRequisites: 'courseModificationChangeRequestCourseRequisites',
};

export default CourseModificationChangeRequestDTO;